import React, {useRef, useState} from 'react';
import styled from 'styled-components';
import InputField from '../components/InputField';
import Loader from '../components/Loader';
import RecommendedSearch from '../components/Search/RecommendedSearch';
import {searchAsync} from '../services/api/search';
import SearchResultGrid from '../components/Search/SearchResultGrid';
import {notWebMediaQuery} from '../styles';
import SearchEmtpy from '../components/Search/SearchEmpty';
import {useSelector} from 'react-redux';
import {getCurrentLocale} from '../utils/i18n';
import SearchPreview from '../components/Search/SearchPreview';
import {useTranslation} from 'react-i18next';
import {analyticsTrackAction} from '../helpers/Analytics';

const Search = () => {
    const [value, setValue] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const currentSearch = useRef('');
    const [searchResults, setSearchResults] = useState(null);
    const [shows, setShows] = useState(null);
    const [games, setGames] = useState(null);
    const user = useSelector(state => state.user);
    let currentCatalog = user.jwtToken
        ? user.catalogTenant
        : getCurrentLocale() === 'por'
        ? 'CNPLUS_LATAM_BR'
        : 'CNPLUS_LATAM_LATAM';

    const onSearch = async value => {
        analyticsTrackAction('search|natural', {
            searchterm: value.toLowerCase(),
            internalsearchevent: '1',
        });
        search(value);
    };

    const fillQuery = query => {
        analyticsTrackAction('search|suggested', {
            searchterm: query.toLowerCase(),
            internalsearchevent: '1',
        });
        setValue(query);
        search(query);
    };

    const search = async value => {
        currentSearch.current = value;
        setIsLoading(true);
        let results = await searchAsync(value, currentCatalog);

        //ignore if another search was started
        if (currentSearch.current !== value) {
            return;
        }
        setIsLoading(false);
        setShows(results.filter(result => result.__typename === 'Show'));
        setGames(results.filter(result => result.__typename === 'Game'));

        setSearchResults(results);
    };

    return (
        <Container>
            <Content>
                <InputField
                    onSearch={onSearch}
                    value={value}
                    onChange={setValue}
                />
                {!isLoading && searchResults && searchResults.length === 0 && (
                    <SearchEmtpy />
                )}
                {isLoading && <CustomLoader />}
                {!isLoading && !searchResults && value.length === 0 && (
                    <RecommendedSearch />
                )}
                {!isLoading && !searchResults && value.length > 0 && (
                    <SearchPreview query={value} onPress={fillQuery} />
                )}

                {!isLoading && <SearchResultGrid shows={shows} games={games} />}

                {!searchResults && (
                    <>
                        <Character />
                        <Balloon />
                    </>
                )}
            </Content>
        </Container>
    );
};

const Container = styled.div`
    background-image: radial-gradient(
        100% 316.05% at 0% 100%,
        #ffd93f 0%,
        #ffd93f 6.34%,
        #00aeef 28.08%,
        #ffd93f 38.29%,
        #ffd93f 64.14%,
        #ec008c 86.86%,
        #ffd93f 96.35%
    );
    flex: 1;
    display: flex;
    min-height: 800px;
    max-width: 1440px;
    align-self: center;
    width: 100%;
`;

const Content = styled.div`
    margin: 20px;
    background-color: #211921;
    flex: 1;
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: column;
    padding: 60px 40px 0px 40px;
    width: calc(100% - 120px);

    ${notWebMediaQuery} {
        margin: 10px;
        padding: 40px 15px 0px 15px;
    }
`;

const Character = styled.img.attrs({
    src: require('../assets/search-character.png'),
})`
    position: absolute;
    bottom: 0px;
    left: 0px;
`;

const CustomLoader = styled(Loader)`
    max-height: 300px;
`;

const Balloon = () => {
    const {t} = useTranslation();
    return (
        <BalloonContainer>
            <BalloonText>{t('search.help')}</BalloonText>
            <BalloonArrow></BalloonArrow>
        </BalloonContainer>
    );
};

const BalloonContainer = styled.div`
    position: absolute;
    bottom: 230px;
    left: 50px;
`;

const BalloonText = styled.div`
    background-color: white;
    border-radius: 6px;
    margin-bottom: -12px;
    color: black;
    padding: 11px;
    font-family: TTNormsProExtraBlack;
    font-style: normal;
    font-weight: 900;
    font-size: 18px;
    line-height: 20px;
    text-align: center;
    text-transform: uppercase;
    white-space: pre-wrap;
`;

const BalloonArrow = styled.img.attrs({
    src: require('../assets/search_balloon_arrow.png'),
})`
    margin-left: 18px;
`;

export default Search;
